/**
 * @fileoverview Active-sessions query hook.
 * @description Wraps GET /identity/sessions, for the Settings page's "active sessions" list.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import { useQuery } from '@tanstack/react-query'

import { getSessions } from '@/features/auth/services/session.service'

export const SESSIONS_QUERY_KEY = ['identity', 'sessions']

/**
 * @description Fetches the signed-in user's own live sessions.
 * @returns {ReturnType<typeof useQuery>} The query object (data, isPending, error, ...).
 */
export function useSessions() {
  return useQuery({
    queryKey: SESSIONS_QUERY_KEY,
    queryFn: getSessions,
  })
}
